import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ContentBox from './ContentBox';

function UserSettingsLayout({ children }) {
    const location = useLocation();
    const activeUrl = location.pathname;

    const settingsLinks = [
        { label: 'Inventory', url: '/members/settings/inventory' },
        { label: 'Statistics', url: '/members/settings/statistics' },
        { label: 'Value Subscriptions', url: '/members/settings/value-subscriptions' },
        { label: 'Framp History', url: '/members/settings/stamp-history' },
        { label: 'Shop History', url: '/members/settings/shop-history' },
        { label: 'GDPR', url: '/members/settings/gdpr' },
    ];

    return (
        <div className="w-full min-h-screen p-4 lg:p-6">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6">
                <div className="lg:col-span-4">
                    <ContentBox theme="default" tint="lightskyblue" header="User Settings">
                        <div className="flex flex-col gap-2">
                            {settingsLinks.map((link, index) => {
                                const isActive = activeUrl === link.url;
                                return (
                                    <Link
                                        key={index}
                                        to={link.url}
                                        className={`font-['Jersey_10'] uppercase text-[16px] tracking-[1px] px-3 py-2 rounded transition-all
                                            ${isActive
                                            ? 'bg-maroon text-white'
                                            : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                                        }`}
                                        style={{
                                            boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.2)'
                                        }}
                                    >
                                        {link.label}
                                    </Link>
                                );
                            })}
                        </div>
                    </ContentBox>
                </div>

                <div className="lg:col-span-8">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default UserSettingsLayout;